import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/savings.css";

export default function Savings() {
  const [amount, setAmount] = useState("");
  const [emotion, setEmotion] = useState("");
  const [note, setNote] = useState("");
  const [entries, setEntries] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  const navigate = useNavigate();

  // Load saved entries
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("pj_savings")) || [];
    setEntries(saved);
  }, []);

  const getWeekOfMonth = (date) => Math.ceil(date.getDate() / 7);

  // Save or update entry
  const handleSave = () => {
    if (!amount) return;

    const now = new Date();
    const newEntry = {
      date: now.toLocaleDateString(),
      week: `Week ${getWeekOfMonth(now)}`,
      amount: parseInt(amount, 10), // store as number
      emotion,
      note,
    };

    let updated;
    if (editIndex !== null) {
      updated = [...entries];
      updated[editIndex] = { ...updated[editIndex], ...newEntry };
      setEditIndex(null);
    } else {
      updated = [newEntry, ...entries];
    }

    setEntries(updated);
    localStorage.setItem("pj_savings", JSON.stringify(updated));

    setAmount("");
    setEmotion("");
    setNote("");
  };

  // Edit an existing entry
  const handleEdit = (index) => {
    const entry = entries[index];
    setAmount(entry.amount.toString()); // string fixes -1 bug
    setEmotion(entry.emotion);
    setNote(entry.note);
    setEditIndex(index);
  };

  // Delete an entry
  const handleDelete = (index) => {
    const updated = entries.filter((_, i) => i !== index);
    setEntries(updated);
    localStorage.setItem("pj_savings", JSON.stringify(updated));
    if (editIndex === index) {
      setAmount("");
      setEmotion("");
      setNote("");
      setEditIndex(null);
    }
  };

  return (
    <div className="savings-container">
      {/* Navigation Buttons */}
      <div className="nav-buttons">
        <button className="nav-btn" onClick={() => navigate("/home")}>🏠 Home</button>
        <button className="nav-btn" onClick={() => navigate("/dashboard")}>📊 Dashboard</button>
      </div>

      <h1>{editIndex !== null ? "Edit Savings" : "Add Savings"}</h1>

      <div className="form-card">
        <label>Amount (₹)</label>
        <input
          type="text"
          value={amount}
          onChange={(e) => {
            const val = e.target.value;
            if (/^\d*$/.test(val)) setAmount(val); // only digits
          }}
          placeholder="e.g. 50"
          onFocus={(e) => e.target.select()}
        />

        <label>Emotion of the week</label>
        <select value={emotion} onChange={(e) => setEmotion(e.target.value)}>
          <option value="">Select emotion</option>
          <option value="😊 Happy">😊 Happy</option>
          <option value="😌 Calm">😌 Calm</option>
          <option value="💪 Proud">💪 Proud</option>
          <option value="🔥 Motivated">🔥 Motivated</option>
          <option value="😤 Stressed">😤 Stressed</option>
          <option value="🥱 Tired">🥱 Tired</option>
          <option value="😔 Low">😔 Low</option>
          <option value="🙏 Grateful">🙏 Grateful</option>
        </select>

        <label>Best thing that happened</label>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Write one good thing ✨"
        />

        <button onClick={handleSave}>
          {editIndex !== null ? "Update Entry" : "Save Entry"}
        </button>
      </div>

      <h2 className="history-title">Recent Entries</h2>

      <div className="entries">
        {entries.length === 0 && <p>No savings yet.</p>}

        {entries.map((e, i) => (
          <div key={i} className="entry-card">
            <div className="row">
              <strong>₹{e.amount}</strong>
              <span>{e.week}</span>
            </div>
            <small>{e.date}</small>
            {e.emotion && <p>🧠 {e.emotion}</p>}
            {e.note && <p>✨ {e.note}</p>}

            <div className="entry-actions">
              <button className="edit-btn" onClick={() => handleEdit(i)}>
                ✏️ Edit
              </button>
              <button className="delete-btn" onClick={() => handleDelete(i)}>
                🗑️ Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
